import { defaultFilterInitialState } from 'shared/reducers/filter/defaultFilterInitialState';
import { moscowCoords } from 'shared/selectors/coordinates';
import { type IBanner } from 'shared/types/banners';
import { type ILocation } from 'shared/types/locations';
import { type IApplicationState, type IHashTableState } from 'shared/types/redux';
import { type IResidentialComplex } from 'shared/types/residentials';

import { defaultUser } from './user';

export const defaultBannersState: IHashTableState<IBanner> = { hash: {}, list: [] };
export const defaultLocationsState: IHashTableState<ILocation> = { hash: {}, list: [] };
export const defaultResidentialComplexesState: IHashTableState<IResidentialComplex> = { hash: {}, list: [] };

export const normalizedBanners = {
  hash: {
    1: {
      hasCommercialProperty: true,
      id: 1,
      imageUrl: 'url1',
      jkId: 1,
      label: 'label1',
      publicUrl: '/zhiloy-kompleks-salarevo-park-moskva-1/',
      title: 'title1',
      transports: [],
    },
    2: {
      hasCommercialProperty: false,
      id: 2,
      imageUrl: 'url2',
      jkId: 2,
      label: 'label2',
      publicUrl: '/zhiloy-kompleks-salarevo-park-moskva-2/',
      title: 'title',
      transports: [],
    },
  },
  list: [
    {
      hasCommercialProperty: true,
      id: 1,
      imageUrl: 'url1',
      jkId: 1,
      label: 'label1',
      publicUrl: '/zhiloy-kompleks-salarevo-park-moskva-1/',
      title: 'title1',
      transports: [],
    },
    {
      hasCommercialProperty: false,
      id: 2,
      imageUrl: 'url2',
      jkId: 2,
      label: 'label2',
      publicUrl: '/zhiloy-kompleks-salarevo-park-moskva-2/',
      title: 'title',
      transports: [],
    },
  ],
};

export const initialState: IApplicationState = {
  adfox: { puids: null },
  banners: normalizedBanners,
  filter: defaultFilterInitialState,
  locations: defaultLocationsState,
  residentialComplexes: defaultResidentialComplexesState,
  residentialComplexesIds: [],
  specialPromosBlocks: {
    banks: [],
    developerAwards: null,
    developerRatings: null,
    facts: [],
    mortgageBanner: null,
    mortgageCalculator: null,
    newbuildingsPlusBlocksPik: [],
    phone: '',
  },
  user: defaultUser,
};

export const residentialComplexes: IResidentialComplex[] = [
  {
    address: 'SPB',
    bankIds: [1, 2, 3],
    coordinates: moscowCoords,
    finishInfo: { label: 'Finish label', years: undefined },
    hasDecoration: true,
    id: 1,
    imgUrl: '',
    maxArea: 300,
    maxPrice: 20000000,
    minArea: 50,
    minPrice: 11111,
    promoLabel: 'Sale 50%',
    publicUrl: '#',
    roomsInfo: undefined,
    title: 'Dream JK',
    transports: [],
    undergroundInfo: { lineColor: 'FFFFFF', title: 'White branch' },
    useDecorationFilter: undefined,
  },
  {
    address: 'MSK',
    bankIds: [3, 4, 5],
    coordinates: moscowCoords,
    finishInfo: { label: 'Finish label', years: undefined },
    hasDecoration: true,
    id: 2,
    imgUrl: '',
    maxArea: 400,
    maxPrice: 30000000,
    minArea: 60,
    minPrice: 21111,
    promoLabel: 'Sale 40%',
    publicUrl: '#',
    roomsInfo: undefined,
    title: 'Dream JK in Moscow',
    transports: [],
    undergroundInfo: { lineColor: '000000', title: 'Black branch' },
    useDecorationFilter: undefined,
  },
];

export const normalizedResidentialComplexes = {
  hash: {
    [residentialComplexes[0].id]: residentialComplexes[0],
    [residentialComplexes[1].id]: residentialComplexes[1],
  },
  list: residentialComplexes,
};

export const residentialComplexesWithPikPlus: IResidentialComplex[] = [
  {
    ...residentialComplexes[0],
    description: 'First description',
    displayType: 'plus',
    equipmentOptions: [
      {
        imageUrl: '1_first_url.png',
        title: "1 First equipment'",
      },
      {
        imageUrl: '1_second_url.png',
        title: "1 Second equipment'",
      },
    ],
  },
  {
    ...residentialComplexes[1],
  },
];

export const normalizedResidentialComplexesWithPikPlus = {
  hash: {
    [residentialComplexesWithPikPlus[0].id]: residentialComplexesWithPikPlus[0],
    [residentialComplexesWithPikPlus[1].id]: residentialComplexesWithPikPlus[1],
  },
  list: residentialComplexesWithPikPlus,
};
